import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'landingPage',
      component: () => import('./views/LandingPage')
    },
    {
      path: '/invite/:inviteId',
      name: 'invite',
      props: true,
      component: () => import('./views/LandingPage/invited'),
      beforeEnter(to, from, next) {
        console.log('test');
        if (!store.getters['auth/isUser']) {
          next();
        } else {
          next({ path: '/workspace/' });
        }
      }
    },
    {
      path: '/context/:contextId/:page?',
      name: 'context',
      component: () => import('./views/Context'),
      props: true
    },
    {
      path: '/newcontext',
      name: 'newContext',
      component: () => import('./components/NewContextGuide'),
      props: true
    },
    {
      path: '/',
      name: 'home',
      beforeEnter(to, from, next) {
        console.log('test');
        if (!store.getters['auth/isUser']) {
          next({ path: '/login' });
        } else {
          next({ path: '/workspace/' });
          // if (store.getters['auth/lastWorkspaceId']) {
          //   //store.commit('userWorkspaceLite/setWorkspaceId', store.getters["auth/lastWorkspaceId"]);
          //   next({ path: '/workspace/' + store.getters['auth/lastWorkspaceId'] });
          // } else {
          //   next({ path: '/workspace/0' });
          // }
        }

        // store
        //   .dispatch('context/checkContextAccessPersmissions', to.params.contextId)
        //   .then(() => {
        //     console.log('allowed');
        //     next();
        //   })
        //   .catch(e => {
        //     console.log('not allowed', e);
        //     next({ path: '/login' });
        //   });
      }
    },
    {
      path: '/workspace/:workspaceId?',
      name: 'workspace',
      component: () => import('./views/Dashboard'),
      props: true,
      beforeRouteEnter(to, from, next) {
        next(); //  check workspace permission
      },
      children: [
        { path: '', name: 'dashboard', component: () => import('./views/Dashboard/MyDashboard/') },
        {
          path: 'contexts',
          name: 'contexts',
          component: () => import('./views/Dashboard/AllContexts/')
        },
        // {
        //   path: 'projects',
        //   name: 'projects',
        //   component: () => import('./views/Dashboard/AllProjects')
        // },
        {
          path: 'resources',
          name: 'resources',
          component: () => import('./views/Dashboard/AllResources')
        }
        // {
        //   path: 'history',
        //   name: 'history',
        //   component: () => import('./views/Dashboard/WorkspaceHistory')
        // }
      ]
    },
    {
      path: '/pdfViewer/:resourceId',
      name: 'pdfViewer',
      props: true,
      component: () => import('./components/PDFModule')
    }
  ]
});

router.afterEach((to, from) => {
  if (to.name === 'context' && from.params.contextId != to.params.contextId) {
    //  update last opened
    store.dispatch('userWorkspaceLite/updateContextLastOpened', {
      contextId: to.params.contextId
    });
  }
});

router.beforeEach(async (to, from, next) => {
  if (from.params.contextId == to.params.contextId) {
    return next();
  }
  if (from.name === 'context') {
    console.log(`from ${from.params.contextId}`);
    await store.dispatch('components/sessionStorage/updateStoredContext', {
      contextId: from.params.contextId
    });
  }
  if (to.name === 'context') {
    store
      .dispatch('context/checkContextAccessPersmissions', to.params.contextId)
      .then(result => {
        //update last opened
        // store.dispatch('userWorkspaceLite/updateContextLastOpened', {
        //   contextId: to.params.contextId
        // });

        //update sessionStorage
        console.log('contextPermissions result', result);
        store.dispatch('components/sessionStorage/updateNewContextState', {
          contextId: to.params.contextId
        });
        console.log('next is running after checking contextPermissions');
        next();
      })
      .catch(e => {
        console.log('context permissions error');
        console.log('not allowed', e);
        next({ path: '/accessDenied' });
        if (store.getters['auth/isUser']) {
          next({ path: 'home' });
        } else {
          next({ path: '/login' });
        }
      });
  } else {
    console.log('not navigating to a context next: ', next);
    next();
  }
});
export default router;
